import { render, staticRenderFns } from "./ToothRemoveControls.vue?vue&type=template&id=28e20389&scoped=true&"
import script from "./ToothRemoveControls.vue?vue&type=script&lang=js&"
export * from "./ToothRemoveControls.vue?vue&type=script&lang=js&"
import style0 from "./ToothRemoveControls.vue?vue&type=style&index=0&id=28e20389&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e20389",
  null
  
)

export default component.exports